import { FETCH_CONVERSATION_RAW_EMAIL } from './actionTypes'

export const buildConversatioRawEmailRequestKey = rawEmailId =>
  `${FETCH_CONVERSATION_RAW_EMAIL}_${rawEmailId}`
